package com.example.mystybag.core.expected

import androidx.compose.runtime.Composable
import com.example.mystybag.sharedmodels.SCImage
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.dom.HTMLInputElement
import org.w3c.files.File
import org.w3c.files.FileReader
import kotlin.coroutines.resume

actual object PlatformHelper {
    actual val isWeb: Boolean = true
    @Composable
    actual fun PlatformView() {}

    actual suspend fun takePhoto(): Pair<FileModel?, String?> = Pair(null, null)

    actual suspend fun openGallery(): Pair<FileModel?, String?> = suspendCancellableCoroutine { cont ->
        val input = (document.createElement("input") as HTMLInputElement).apply {
            type = "file"
            accept = "image/*"
            style.display = "none"
        }
        input.onchange = { _ ->
            val file = input.files?.item(0) as? File
            if (file != null) {
                val reader = FileReader()
                reader.onload = { _ ->
                    val result = reader.result
                    if (result != null) {
                        val bytes = arrayBufferToByteArray(result.unsafeCast<dynamic>())
                        val fileModel = FileModel(uri = file.name, type = FileModelType.Image).apply {
                            setImageBytes(bytes)
                        }
                        cont.resume(Pair(fileModel, null))
                    } else {
                        cont.resume(Pair(null, "Failed to read image"))
                    }
                }
                reader.onerror = { cont.resume(Pair(null, "Failed to read file")) }
                reader.readAsArrayBuffer(file)
            } else {
                cont.resume(Pair(null, null))
            }
            document.body?.removeChild(input)
        }
        document.body?.appendChild(input)
        input.click()
    }

    actual suspend fun getFile(): Pair<FileModel?, String?> = Pair(null, null)
}

private fun arrayBufferToByteArray(buffer: dynamic): ByteArray {
    val arr = (js("(function(b) { return new Uint8Array(b); })") as (dynamic) -> dynamic)(buffer)
    val len = arr.length as Int
    return ByteArray(len) { (arr[it] as Int).toByte() }
}

actual class FileModel actual constructor(uri: String, type: FileModelType) {
    private var _imageBytes: ByteArray? = null

    internal fun setImageBytes(bytes: ByteArray) {
        _imageBytes = bytes
    }

    actual val fileType: FileModelType = type
    actual val image: SCImage? get() = _imageBytes?.let { SCImage(it) }
    actual val byteArray: ByteArray? get() = _imageBytes
    actual val path: String? = uri
    actual val name: String = uri.substringAfterLast('/').ifEmpty { "image" }
}
